import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { map } from 'rxjs';
import { ACCOUNT_GROUP_ID_TOKEN, CONVERSATION_ROUTES_TOKEN } from '../../../../../core/src/index';
import { SmsModule } from '@galaxy/sms';

@Component({
  selector: 'inbox-sms-registration',
  imports: [CommonModule, SmsModule, GalaxyPageModule, TranslateModule],
  templateUrl: './sms-registration.component.html',
})
export class SmsRegistrationComponent {
  private readonly routes = toSignal(inject(CONVERSATION_ROUTES_TOKEN));
  private readonly accountGroupId$ = inject(ACCOUNT_GROUP_ID_TOKEN);

  readonly previousPageRoute$ = this.accountGroupId$.pipe(
    map((id) => {
      if (this.routes()?.useModal) {
        return `./(inbox:inbox/settings)`;
      } else {
        return `/account/location/${id}/settings/inbox`;
      }
    }),
  );
}
